import { Button, Grid, Typography } from "@mui/material";
import { createPortal } from "react-dom";

import { Backdrop, ModalContainer } from "./DeleteModal.style";

function DeleteModal(props) {
  return createPortal(
    <>
      <Backdrop isShown={props.show} onClick={props.onClose}>
        <ModalContainer
          onClick={(e) => e.stopPropagation()}
          isShown={props.show}
        >
          <Grid container spacing={2} mt={8} justifyContent={"center"}>
            <Grid item xs={12} mb={4}>
              <Typography sx={{ textAlign: "center" }}>
                {props.title ?? "آیا از حذف مطمئن هستید؟"}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                color="info"
                fullWidth
                onClick={props.onDelete}
              >
                {props.confirmTitle ?? "بله"}
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="text"
                color="error"
                fullWidth
                onClick={props.onClose}
              >
                {props.cancelTitle ?? "خیر"}
              </Button>
            </Grid>
          </Grid>
        </ModalContainer>
      </Backdrop>
    </>,
    document.getElementById("modal")
  );
}

export default DeleteModal;
